webpackJsonp([1],{

/***/ "+6aW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h1',[_vm._v("contact")]),_vm._v(" "),_c('p',[_vm._v("Feel free to contact me if you have any idea need to realize")]),_vm._v(" "),_c('p',[_vm._v("You can send email to me or leave a message")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('guest-book')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Email :\n      "),_c('a',{attrs:{"href":"mailto:neta.edmond@gmail.com"}},[_vm._v("neta.edmond@gmail.com")]),_vm._v(" "),_c('a',{attrs:{"href":"https://github.com/edmondyip","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("GitHub @edmondyip")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+aM5":
/***/ (function(module, exports) {

module.exports = {"projects":[{"id":1,"name":"Eventor","date":"2015","typeList":["UX Design","UI Design"],"techList":["Sketch","Photoshop"],"description":"Eventor Android iOS APP Design","path":"eventor","gallery":[{"title":"Concept Image","imageType":"desktop","fileName":"banner1.jpg"},{"title":"Concept Image","imageType":"desktop","fileName":"banner2.jpg"},{"title":"UX","imageType":"desktop","fileName":"ux.jpg"}],"themeColor":"#FFC056"},{"id":2,"name":"Cloudnifier","date":"2016","typeList":["UI Design","Wordpress"],"techList":["Sketch","Photoshop"],"description":"Cloudnifier Offical Website","path":"cloudnifier","gallery":[{"title":"Landing Page","imageType":"desktop","fileName":"cover.jpg"}],"themeColor":"#4D7EC2"},{"id":3,"name":"Merchant Plus","date":"2016","typeList":["UI Design"],"techList":["Sketch","Photoshop"],"description":"Merchant Tablet UX UI design","path":"merchant-plus","gallery":[{"title":"Landing Page","imageType":"desktop","fileName":"login.jpg"},{"title":"Produst List","imageType":"desktop","fileName":"collection.jpg"},{"title":"Produst","imageType":"desktop","fileName":"collection2.jpg"}],"themeColor":"#7FEFBF"},{"id":4,"name":"Student Smart","date":"2016","typeList":["UX Design","UI Design"],"techList":["Sketch","Photoshop"],"description":"Student Management System","path":"student-smart","gallery":[{"title":"Concept Image","imageType":"desktop","fileName":"profile.png"},{"title":"Concept Image","imageType":"desktop","fileName":"student.png"},{"title":"UX flow","imageType":"desktop","fileName":"bookmark.jpg"}],"themeColor":"#85E075"},{"id":5,"name":"Disenyland","date":"2016","typeList":["UI Design"],"techList":["Photoshop"],"description":"Disenyland Survey","path":"disenyland","gallery":[{"title":"Survey","imageType":"desktop","fileName":"cover.jpg"}],"themeColor":"#A4DCE0"},{"id":6,"name":"Hatchya","date":"2015","typeList":["Web Design","Info Graphic"],"techList":["Sketch","Photoshop"],"description":"Hatchya website","path":"hatchya","gallery":[{"title":"Landing Page","imageType":"desktop","fileName":"login.jpg"},{"title":"Product List","imageType":"desktop","fileName":"banner.jpg"},{"title":"Product Card","imageType":"desktop","fileName":"card.jpg"},{"title":"infographic","imageType":"desktop","fileName":"infographic.jpg"},{"title":"infographic","imageType":"desktop","fileName":"infographic2.jpg"}],"themeColor":"#FFC056"},{"id":7,"name":"Management System","date":"2015","typeList":["UX Design","UI Design"],"techList":["Sketch","Photoshop"],"description":"Brand Asset Management System","path":"management","gallery":[{"title":"Landing Page","imageType":"desktop","fileName":"login.jpg"},{"title":"Dashboard","imageType":"desktop","fileName":"dashboard.jpg"},{"title":"Request","imageType":"desktop","fileName":"request.jpg"},{"title":"Floor plan","imageType":"desktop","fileName":"floorplan.jpg"}],"themeColor":"#1F7BC6"},{"id":8,"name":"Canon","date":"2016","typeList":["UI Design","UX Design"],"techList":["Sketch","Illustrator"],"description":"Canon Promoter App","path":"canon","gallery":[{"title":"Login and Dashboard","imageType":"desktop","fileName":"cover.jpg"},{"title":"Main Screen","imageType":"mobile","fileName":"main.jpg"},{"title":"UX Design","imageType":"desktop","fileName":"ux.jpg"}],"themeColor":"#E27979"},{"id":9,"name":"Glasses Gallery","date":"2017","typeList":["Web Design","Front-end","SEO"],"techList":["Angular","Sketch","Illustrator"],"description":"Glasses Gallery Website","path":"glassesgallery","gallery":[{"title":"Homepage","imageType":"desktop","fileName":"cover.jpg"},{"title":"Products List","imageType":"desktop","fileName":"list.jpg"},{"title":"Product Page","imageType":"desktop","fileName":"content.jpg"}],"themeColor":"#4a4a4a"},{"id":10,"name":"Swisscoat","date":"2017","typeList":["Web Design","Front-end","SEO","Blog"],"techList":["Php","VueJs","Photoshop","Sketch","Wordpress"],"description":"Swisscoat Website","path":"swisscoat","gallery":[{"title":"Index","imageType":"desktop","fileName":"index.jpg"},{"title":"Eye Exam","imageType":"desktop","fileName":"test.jpg"},{"title":"Lens","imageType":"desktop","fileName":"lens.jpg"},{"title":"Simlation","imageType":"desktop","fileName":"sim.jpg"},{"title":"Blog","imageType":"desktop","fileName":"blog.jpg"}],"themeColor":"#0064AE"},{"id":11,"name":"SVG-Morpheus","date":"2017","typeList":["Open Source","Side Project"],"techList":["Javascript","GitHub"],"description":"Add support for SVG a Javascript","path":"svg-morpheus","gallery":[{"title":"Cover","imageType":"desktop","fileName":"cover.jpg"}],"themeColor":"#41b883"},{"id":12,"name":"Chinese Fonts","date":"2017","typeList":["Open Source","Side Project"],"techList":["Web Fonts","Javascript","GitHub"],"description":"Convert text to web fonts","path":"chinese-fonts","gallery":[{"title":"Cover","imageType":"desktop","fileName":"cover.jpg"}],"themeColor":"#666666"}]}

/***/ }),

/***/ "0AzE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0CHp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Guestbook',
  data: function data() {
    return {
      comments: [],
      errors: [],
      cmName: '',
      cmEmail: '',
      cmContent: '',
      message: ''
    };
  },
  methods: {
    sendComment: function sendComment() {
      var _this = this;

      _axios2.default.post('https://dev.256pages.com/comments', {
        name: this.cmName,
        email: this.cmEmail,
        content: this.cmContent
      }).then(function (response) {
        _this.cmName = '';
        _this.cmEmail = '';
        _this.cmContent = '';
        _this.message = 'thank you';
      }).catch(function (e) {
        _this.errors.push(e);
      });
    }
  }
};

/***/ }),

/***/ "0jOp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h1',[_vm._v("404")]),_vm._v(" "),_c('h2',[_vm._v("page not found")]),_vm._v(" "),_c('p',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("back to home")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0lwl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home.64cf824.png";

/***/ }),

/***/ "149w":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/card.3f2c1ff.jpg";

/***/ }),

/***/ "1h50":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/infographic2.e9d666b.jpg";

/***/ }),

/***/ "2h4B":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'NotFound',
  metaInfo: {
    title: 'Page not found'
  }
};

/***/ }),

/***/ "2yqe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"video-container"},[_c('transition',{attrs:{"name":"videoAnimation","appear":"","appear-active-class":"video-animation"},on:{"after-appear":_vm.afterVideo}},[_c('div',{staticClass:"video-wrapper"},[_c('video',{attrs:{"id":"youtube","autoplay":"","loop":"","muted":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":__webpack_require__("x/g7"),"type":"video/mp4"}})])])]),_vm._v(" "),_c('transition',{attrs:{"name":"logo"}},[(_vm.logoAnimation === true)?_c('div',{staticClass:"video-logo"},[_c('span',[_vm._v("弐伍")]),_vm._v(" "),_c('span',[_vm._v("陸頁")])]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"title-container"},[_c('transition',{attrs:{"name":"title"}},[(_vm.titleAnimation === true)?_c('h1',{staticClass:"index-title"},[_vm._v("edmond yip design portfolio")]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"small-name"}},[(_vm.nameAnimation === true)?_c('h2',{staticClass:"index-small-name"},[_vm._v("two hundred and fifty six pages")]):_vm._e()])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3PfS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About256_vue__ = __webpack_require__("E+Rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About256_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About256_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About256_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About256_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30f67ce5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About256_vue__ = __webpack_require__("gH4x");
function injectStyle (ssrContext) {
  __webpack_require__("pBNn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-30f67ce5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About256_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30f67ce5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About256_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "4JzW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4cvJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Comments',
  data: function data() {
    return {
      comments: [],
      errors: [],
      checkedCm: []
    };
  },
  created: function created() {
    this.loadApi();
  },
  methods: {
    loadApi: function loadApi() {
      var _this = this;

      _axios2.default.get('https://dev.256pages.com/comments').then(function (response) {
        _this.comments = response.data;
      }).catch(function (e) {
        _this.errors.push(e);
      });
    },
    timeCheck: function timeCheck(time) {
      return (0, _moment2.default)(time).format("Do MMM, h:mm a");
    },
    delCm: function delCm() {
      var _this2 = this;

      _axios2.default.delete('https://dev.256pages.com/comments/' + this.checkedCm).then(function (response) {
        _this2.loadApi();
        _this2.checkCm = [];
      }).catch(function (e) {
        _this2.errors.push(e);
      });
    }
  }
};

/***/ }),

/***/ "5FwO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/content.77d3231.jpg";

/***/ }),

/***/ "61mf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SVGMorpheus = function () {
  'use strict';

  var easings = {};
  easings['circ-in'] = function (t) {
    return -1 * (Math.sqrt(1 - t * t) - 1);
  };
  easings['circ-out'] = function (t) {
    return Math.sqrt(1 - (t = t - 1) * t);
  };
  easings['circ-in-out'] = function (t) {
    if ((t /= 1 / 2) < 1) return -1 / 2 * (Math.sqrt(1 - t * t) - 1);
    return 1 / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1);
  };
  easings['cubic-in'] = function (t) {
    return t * t * t;
  };
  easings['cubic-out'] = function (t) {
    return --t * t * t + 1;
  };
  easings['cubic-in-out'] = function (t) {
    return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
  };
  easings['elastic-in'] = function (t) {
    var s = 1.70158;var p = 0;var a = 1;
    if (t == 0) return 0;if (t == 1) return 1;if (!p) p = .3;
    if (a < Math.abs(1)) {
      a = 1;var s = p / 4;
    } else var s = p / (2 * Math.PI) * Math.asin(1 / a);
    return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
  };
  easings['elastic-out'] = function (t) {
    var s = 1.70158;var p = 0;var a = 1;
    if (t == 0) return 0;if (t == 1) return 1;if (!p) p = .3;
    if (a < Math.abs(1)) {
      a = 1;var s = p / 4;
    } else var s = p / (2 * Math.PI) * Math.asin(1 / a);
    return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
  };
  easings['elastic-in-out'] = function (t) {
    var s = 1.70158;var p = 0;var a = 1;
    if (t == 0) return 0;if ((t /= 1 / 2) == 2) return 1;if (!p) p = 1 * (.3 * 1.5);
    if (a < Math.abs(1)) {
      a = 1;var s = p / 4;
    } else var s = p / (2 * Math.PI) * Math.asin(1 / a);
    if (t < 1) return -.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
    return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * .5 + 1;
  };
  easings['expo-in'] = function (t) {
    return t == 0 ? 0 : Math.pow(2, 10 * (t - 1));
  };
  easings['expo-out'] = function (t) {
    return t == 1 ? 1 : 1 - Math.pow(2, -10 * t);
  };
  easings['expo-in-out'] = function (t) {
    if (t == 0) return 0;
    if (t == 1) return 1;
    if ((t /= 1 / 2) < 1) return 1 / 2 * Math.pow(2, 10 * (t - 1));
    return 1 / 2 * (-Math.pow(2, -10 * --t) + 2);
  };
  easings['linear'] = function (t) {
    return t;
  };
  easings['quad-in'] = function (t) {
    return t * t;
  };
  easings['quad-out'] = function (t) {
    return t * (2 - t);
  };
  easings['quad-in-out'] = function (t) {
    return t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  };
  easings['quart-in'] = function (t) {
    return t * t * t * t;
  };
  easings['quart-out'] = function (t) {
    return 1 - --t * t * t * t;
  };
  easings['quart-in-out'] = function (t) {
    return t < .5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
  };
  easings['quint-in'] = function (t) {
    return t * t * t * t * t;
  };
  easings['quint-out'] = function (t) {
    return 1 + --t * t * t * t * t;
  };
  easings['quint-in-out'] = function (t) {
    return t < .5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
  };
  easings['sine-in'] = function (t) {
    return 1 - Math.cos(t * (Math.PI / 2));
  };
  easings['sine-out'] = function (t) {
    return Math.sin(t * (Math.PI / 2));
  };
  easings['sine-in-out'] = function (t) {
    return 1 / 2 * (1 - Math.cos(Math.PI * t));
  };

  var _reqAnimFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.oRequestAnimationFrame;
  var _cancelAnimFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame || window.oCancelAnimationFrame;

  function styleNormCalc(styleNormFrom, styleNormTo, progress) {
    var i,
        len,
        styleNorm = {};
    for (i in styleNormFrom) {
      switch (i) {
        case 'fill':
        case 'stroke':
          styleNorm[i] = clone(styleNormFrom[i]);
          styleNorm[i].r = styleNormFrom[i].r + (styleNormTo[i].r - styleNormFrom[i].r) * progress;
          styleNorm[i].g = styleNormFrom[i].g + (styleNormTo[i].g - styleNormFrom[i].g) * progress;
          styleNorm[i].b = styleNormFrom[i].b + (styleNormTo[i].b - styleNormFrom[i].b) * progress;
          styleNorm[i].opacity = styleNormFrom[i].opacity + (styleNormTo[i].opacity - styleNormFrom[i].opacity) * progress;
          break;
        case 'opacity':
        case 'fill-opacity':
        case 'stroke-opacity':
        case 'stroke-width':
          styleNorm[i] = styleNormFrom[i] + (styleNormTo[i] - styleNormFrom[i]) * progress;
          break;
      }
    }
    return styleNorm;
  }

  function styleNormToString(styleNorm) {
    var i;
    var style = {};
    for (i in styleNorm) {
      switch (i) {
        case 'fill':
        case 'stroke':
          style[i] = rgbToString(styleNorm[i]);
          break;
        case 'opacity':
        case 'fill-opacity':
        case 'stroke-opacity':
        case 'stroke-width':
          style[i] = styleNorm[i];
          break;
      }
    }
    return style;
  }

  function styleToNorm(styleFrom, styleTo) {
    var styleNorm = [{}, {}];
    var i;
    for (i in styleFrom) {
      switch (i) {
        case 'fill':
        case 'stroke':
          styleNorm[0][i] = getRGB(styleFrom[i]);
          if (styleTo[i] === undefined) {
            styleNorm[1][i] = getRGB(styleFrom[i]);
            styleNorm[1][i].opacity = 0;
          }
          break;
        case 'opacity':
        case 'fill-opacity':
        case 'stroke-opacity':
        case 'stroke-width':
          styleNorm[0][i] = styleFrom[i];
          if (styleTo[i] === undefined) {
            styleNorm[1][i] = 1;
          }
          break;
      }
    }
    for (i in styleTo) {
      switch (i) {
        case 'fill':
        case 'stroke':
          styleNorm[1][i] = getRGB(styleTo[i]);
          if (styleFrom[i] === undefined) {
            styleNorm[0][i] = getRGB(styleTo[i]);
            styleNorm[0][i].opacity = 0;
          }
          break;
        case 'opacity':
        case 'fill-opacity':
        case 'stroke-opacity':
        case 'stroke-width':
          styleNorm[1][i] = styleTo[i];
          if (styleFrom[i] === undefined) {
            styleNorm[0][i] = 1;
          }
          break;
      }
    }
    return styleNorm;
  }

  function transCalc(transFrom, transTo, progress) {
    var res = {};
    for (var i in transFrom) {
      switch (i) {
        case 'rotate':
          res[i] = [0, 0, 0];
          for (var j = 0; j < 3; j++) {
            res[i][j] = transFrom[i][j] + (transTo[i][j] - transFrom[i][j]) * progress;
          }
          break;
      }
    }
    return res;
  }

  function trans2string(trans) {
    var res = '';
    if (!!trans.rotate) {
      res += 'rotate(' + trans.rotate.join(' ') + ')';
    }
    return res;
  }

  function curveCalc(curveFrom, curveTo, progress) {
    var curve = [];
    for (var i = 0, len1 = curveFrom.length; i < len1; i++) {
      curve.push([curveFrom[i][0]]);
      for (var j = 1, len2 = curveFrom[i].length; j < len2; j++) {
        curve[i].push(curveFrom[i][j] + (curveTo[i][j] - curveFrom[i][j]) * progress);
      }
    }
    return curve;
  }

  function clone(obj) {
    var copy;

    if (obj instanceof Array) {
      copy = [];
      for (var i = 0, len = obj.length; i < len; i++) {
        copy[i] = clone(obj[i]);
      }
      return copy;
    }

    if (obj instanceof Object) {
      copy = {};
      for (var attr in obj) {
        if (obj.hasOwnProperty(attr)) {
          copy[attr] = clone(obj[attr]);
        }
      }
      return copy;
    }

    return obj;
  }

  var spaces = '\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029';
  var pathCommand = new RegExp("([a-z])[" + spaces + ",]*((-?\\d*\\.?\\d*(?:e[\\-+]?\\d+)?[" + spaces + "]*,?[" + spaces + "]*)+)", "ig");
  var pathValues = new RegExp("(-?\\d*\\.?\\d*(?:e[\\-+]?\\d+)?)[" + spaces + "]*,?[" + spaces + "]*", "ig");

  var parsePathString = function parsePathString(pathString) {
    if (!pathString) {
      return null;
    }

    if ((typeof pathString === 'undefined' ? 'undefined' : (0, _typeof3.default)(pathString)) === (0, _typeof3.default)([])) {
      return pathString;
    } else {
      var paramCounts = { a: 7, c: 6, o: 2, h: 1, l: 2, m: 2, r: 4, q: 4, s: 4, t: 2, v: 1, u: 3, z: 0 },
          data = [];

      String(pathString).replace(pathCommand, function (a, b, c) {
        var params = [],
            name = b.toLowerCase();
        c.replace(pathValues, function (a, b) {
          b && params.push(+b);
        });
        if (name == "m" && params.length > 2) {
          data.push([b].concat(params.splice(0, 2)));
          name = "l";
          b = b == "m" ? "l" : "L";
        }
        if (name == "o" && params.length == 1) {
          data.push([b, params[0]]);
        }
        if (name == "r") {
          data.push([b].concat(params));
        } else while (params.length >= paramCounts[name]) {
          data.push([b].concat(params.splice(0, paramCounts[name])));
          if (!paramCounts[name]) {
            break;
          }
        }
      });

      return data;
    }
  };

  var catmullRom2bezier = function catmullRom2bezier(crp, z) {
    var d = [];
    for (var i = 0, iLen = crp.length; iLen - 2 * !z > i; i += 2) {
      var p = [{ x: +crp[i - 2], y: +crp[i - 1] }, { x: +crp[i], y: +crp[i + 1] }, { x: +crp[i + 2], y: +crp[i + 3] }, { x: +crp[i + 4], y: +crp[i + 5] }];
      if (z) {
        if (!i) {
          p[0] = { x: +crp[iLen - 2], y: +crp[iLen - 1] };
        } else if (iLen - 4 == i) {
          p[3] = { x: +crp[0], y: +crp[1] };
        } else if (iLen - 2 == i) {
          p[2] = { x: +crp[0], y: +crp[1] };
          p[3] = { x: +crp[2], y: +crp[3] };
        }
      } else {
        if (iLen - 4 == i) {
          p[3] = p[2];
        } else if (!i) {
          p[0] = { x: +crp[i], y: +crp[i + 1] };
        }
      }
      d.push(["C", (-p[0].x + 6 * p[1].x + p[2].x) / 6, (-p[0].y + 6 * p[1].y + p[2].y) / 6, (p[1].x + 6 * p[2].x - p[3].x) / 6, (p[1].y + 6 * p[2].y - p[3].y) / 6, p[2].x, p[2].y]);
    }

    return d;
  };

  var ellipsePath = function ellipsePath(x, y, rx, ry, a) {
    if (a == null && ry == null) {
      ry = rx;
    }
    x = +x;
    y = +y;
    rx = +rx;
    ry = +ry;
    if (a != null) {
      var rad = Math.PI / 180,
          x1 = x + rx * Math.cos(-ry * rad),
          x2 = x + rx * Math.cos(-a * rad),
          y1 = y + rx * Math.sin(-ry * rad),
          y2 = y + rx * Math.sin(-a * rad),
          res = [["M", x1, y1], ["A", rx, rx, 0, +(a - ry > 180), 0, x2, y2]];
    } else {
      res = [["M", x, y], ["m", 0, -ry], ["a", rx, ry, 0, 1, 1, 0, 2 * ry], ["a", rx, ry, 0, 1, 1, 0, -2 * ry], ["z"]];
    }
    return res;
  };

  var pathToAbsolute = function pathToAbsolute(pathArray) {
    pathArray = parsePathString(pathArray);

    if (!pathArray || !pathArray.length) {
      return [["M", 0, 0]];
    }
    var res = [],
        x = 0,
        y = 0,
        mx = 0,
        my = 0,
        start = 0,
        pa0;
    if (pathArray[0][0] == "M") {
      x = +pathArray[0][1];
      y = +pathArray[0][2];
      mx = x;
      my = y;
      start++;
      res[0] = ["M", x, y];
    }
    var crz = pathArray.length == 3 && pathArray[0][0] == "M" && pathArray[1][0].toUpperCase() == "R" && pathArray[2][0].toUpperCase() == "Z";
    for (var r, pa, i = start, ii = pathArray.length; i < ii; i++) {
      res.push(r = []);
      pa = pathArray[i];
      pa0 = pa[0];
      if (pa0 != pa0.toUpperCase()) {
        r[0] = pa0.toUpperCase();
        switch (r[0]) {
          case "A":
            r[1] = pa[1];
            r[2] = pa[2];
            r[3] = pa[3];
            r[4] = pa[4];
            r[5] = pa[5];
            r[6] = +pa[6] + x;
            r[7] = +pa[7] + y;
            break;
          case "V":
            r[1] = +pa[1] + y;
            break;
          case "H":
            r[1] = +pa[1] + x;
            break;
          case "R":
            var dots = [x, y].concat(pa.slice(1));
            for (var j = 2, jj = dots.length; j < jj; j++) {
              dots[j] = +dots[j] + x;
              dots[++j] = +dots[j] + y;
            }
            res.pop();
            res = res.concat(catmullRom2bezier(dots, crz));
            break;
          case "O":
            res.pop();
            dots = ellipsePath(x, y, pa[1], pa[2]);
            dots.push(dots[0]);
            res = res.concat(dots);
            break;
          case "U":
            res.pop();
            res = res.concat(ellipsePath(x, y, pa[1], pa[2], pa[3]));
            r = ["U"].concat(res[res.length - 1].slice(-2));
            break;
          case "M":
            mx = +pa[1] + x;
            my = +pa[2] + y;
          default:
            for (j = 1, jj = pa.length; j < jj; j++) {
              r[j] = +pa[j] + (j % 2 ? x : y);
            }
        }
      } else if (pa0 == "R") {
        dots = [x, y].concat(pa.slice(1));
        res.pop();
        res = res.concat(catmullRom2bezier(dots, crz));
        r = ["R"].concat(pa.slice(-2));
      } else if (pa0 == "O") {
        res.pop();
        dots = ellipsePath(x, y, pa[1], pa[2]);
        dots.push(dots[0]);
        res = res.concat(dots);
      } else if (pa0 == "U") {
        res.pop();
        res = res.concat(ellipsePath(x, y, pa[1], pa[2], pa[3]));
        r = ["U"].concat(res[res.length - 1].slice(-2));
      } else {
        for (var k = 0, kk = pa.length; k < kk; k++) {
          r[k] = pa[k];
        }
      }
      pa0 = pa0.toUpperCase();
      if (pa0 != "O") {
        switch (r[0]) {
          case "Z":
            x = +mx;
            y = +my;
            break;
          case "H":
            x = r[1];
            break;
          case "V":
            y = r[1];
            break;
          case "M":
            mx = r[r.length - 2];
            my = r[r.length - 1];
          default:
            x = r[r.length - 2];
            y = r[r.length - 1];
        }
      }
    }

    return res;
  };

  var l2c = function l2c(x1, y1, x2, y2) {
    return [x1, y1, x2, y2, x2, y2];
  };
  var q2c = function q2c(x1, y1, ax, ay, x2, y2) {
    var _13 = 1 / 3,
        _23 = 2 / 3;
    return [_13 * x1 + _23 * ax, _13 * y1 + _23 * ay, _13 * x2 + _23 * ax, _13 * y2 + _23 * ay, x2, y2];
  };
  var a2c = function a2c(x1, y1, rx, ry, angle, large_arc_flag, sweep_flag, x2, y2, recursive) {
    var _120 = Math.PI * 120 / 180,
        rad = Math.PI / 180 * (+angle || 0),
        res = [],
        xy,
        rotate = function rotate(x, y, rad) {
      var X = x * Math.cos(rad) - y * Math.sin(rad),
          Y = x * Math.sin(rad) + y * Math.cos(rad);
      return { x: X, y: Y };
    };
    if (!recursive) {
      xy = rotate(x1, y1, -rad);
      x1 = xy.x;
      y1 = xy.y;
      xy = rotate(x2, y2, -rad);
      x2 = xy.x;
      y2 = xy.y;
      var cos = Math.cos(Math.PI / 180 * angle),
          sin = Math.sin(Math.PI / 180 * angle),
          x = (x1 - x2) / 2,
          y = (y1 - y2) / 2;
      var h = x * x / (rx * rx) + y * y / (ry * ry);
      if (h > 1) {
        h = Math.sqrt(h);
        rx = h * rx;
        ry = h * ry;
      }
      var rx2 = rx * rx,
          ry2 = ry * ry,
          k = (large_arc_flag == sweep_flag ? -1 : 1) * Math.sqrt(Math.abs((rx2 * ry2 - rx2 * y * y - ry2 * x * x) / (rx2 * y * y + ry2 * x * x))),
          cx = k * rx * y / ry + (x1 + x2) / 2,
          cy = k * -ry * x / rx + (y1 + y2) / 2,
          f1 = Math.asin(((y1 - cy) / ry).toFixed(9)),
          f2 = Math.asin(((y2 - cy) / ry).toFixed(9));

      f1 = x1 < cx ? Math.PI - f1 : f1;
      f2 = x2 < cx ? Math.PI - f2 : f2;
      f1 < 0 && (f1 = Math.PI * 2 + f1);
      f2 < 0 && (f2 = Math.PI * 2 + f2);
      if (sweep_flag && f1 > f2) {
        f1 = f1 - Math.PI * 2;
      }
      if (!sweep_flag && f2 > f1) {
        f2 = f2 - Math.PI * 2;
      }
    } else {
      f1 = recursive[0];
      f2 = recursive[1];
      cx = recursive[2];
      cy = recursive[3];
    }
    var df = f2 - f1;
    if (Math.abs(df) > _120) {
      var f2old = f2,
          x2old = x2,
          y2old = y2;
      f2 = f1 + _120 * (sweep_flag && f2 > f1 ? 1 : -1);
      x2 = cx + rx * Math.cos(f2);
      y2 = cy + ry * Math.sin(f2);
      res = a2c(x2, y2, rx, ry, angle, 0, sweep_flag, x2old, y2old, [f2, f2old, cx, cy]);
    }
    df = f2 - f1;
    var c1 = Math.cos(f1),
        s1 = Math.sin(f1),
        c2 = Math.cos(f2),
        s2 = Math.sin(f2),
        t = Math.tan(df / 4),
        hx = 4 / 3 * rx * t,
        hy = 4 / 3 * ry * t,
        m1 = [x1, y1],
        m2 = [x1 + hx * s1, y1 - hy * c1],
        m3 = [x2 + hx * s2, y2 - hy * c2],
        m4 = [x2, y2];
    m2[0] = 2 * m1[0] - m2[0];
    m2[1] = 2 * m1[1] - m2[1];
    if (recursive) {
      return [m2, m3, m4].concat(res);
    } else {
      res = [m2, m3, m4].concat(res).join().split(",");
      var newres = [];
      for (var i = 0, ii = res.length; i < ii; i++) {
        newres[i] = i % 2 ? rotate(res[i - 1], res[i], rad).y : rotate(res[i], res[i + 1], rad).x;
      }
      return newres;
    }
  };

  var path2curve = function path2curve(path, path2) {
    var p = pathToAbsolute(path),
        p2 = path2 && pathToAbsolute(path2),
        attrs = { x: 0, y: 0, bx: 0, by: 0, X: 0, Y: 0, qx: null, qy: null },
        attrs2 = { x: 0, y: 0, bx: 0, by: 0, X: 0, Y: 0, qx: null, qy: null },
        processPath = function processPath(path, d, pcom) {
      var nx, ny;
      if (!path) {
        return ["C", d.x, d.y, d.x, d.y, d.x, d.y];
      }
      !(path[0] in { T: 1, Q: 1 }) && (d.qx = d.qy = null);
      switch (path[0]) {
        case "M":
          d.X = path[1];
          d.Y = path[2];
          break;
        case "A":
          path = ["C"].concat(a2c.apply(0, [d.x, d.y].concat(path.slice(1))));
          break;
        case "S":
          if (pcom == "C" || pcom == "S") {
            nx = d.x * 2 - d.bx;
            ny = d.y * 2 - d.by;
          } else {
            nx = d.x;
            ny = d.y;
          }
          path = ["C", nx, ny].concat(path.slice(1));
          break;
        case "T":
          if (pcom == "Q" || pcom == "T") {
            d.qx = d.x * 2 - d.qx;
            d.qy = d.y * 2 - d.qy;
          } else {
            d.qx = d.x;
            d.qy = d.y;
          }
          path = ["C"].concat(q2c(d.x, d.y, d.qx, d.qy, path[1], path[2]));
          break;
        case "Q":
          d.qx = path[1];
          d.qy = path[2];
          path = ["C"].concat(q2c(d.x, d.y, path[1], path[2], path[3], path[4]));
          break;
        case "L":
          path = ["C"].concat(l2c(d.x, d.y, path[1], path[2]));
          break;
        case "H":
          path = ["C"].concat(l2c(d.x, d.y, path[1], d.y));
          break;
        case "V":
          path = ["C"].concat(l2c(d.x, d.y, d.x, path[1]));
          break;
        case "Z":
          path = ["C"].concat(l2c(d.x, d.y, d.X, d.Y));
          break;
      }
      return path;
    },
        fixArc = function fixArc(pp, i) {
      if (pp[i].length > 7) {
        pp[i].shift();
        var pi = pp[i];
        while (pi.length) {
          pcoms1[i] = "A";
          p2 && (pcoms2[i] = "A");
          pp.splice(i++, 0, ["C"].concat(pi.splice(0, 6)));
        }
        pp.splice(i, 1);
        ii = Math.max(p.length, p2 && p2.length || 0);
      }
    },
        fixM = function fixM(path1, path2, a1, a2, i) {
      if (path1 && path2 && path1[i][0] == "M" && path2[i][0] != "M") {
        path2.splice(i, 0, ["M", a2.x, a2.y]);
        a1.bx = 0;
        a1.by = 0;
        a1.x = path1[i][1];
        a1.y = path1[i][2];
        ii = Math.max(p.length, p2 && p2.length || 0);
      }
    },
        pcoms1 = [],
        pcoms2 = [],
        pfirst = "",
        pcom = "";
    for (var i = 0, ii = Math.max(p.length, p2 && p2.length || 0); i < ii; i++) {
      p[i] && (pfirst = p[i][0]);

      if (pfirst != "C") {
        pcoms1[i] = pfirst;
        i && (pcom = pcoms1[i - 1]);
      }
      p[i] = processPath(p[i], attrs, pcom);

      if (pcoms1[i] != "A" && pfirst == "C") pcoms1[i] = "C";

      fixArc(p, i);

      if (p2) {
        p2[i] && (pfirst = p2[i][0]);
        if (pfirst != "C") {
          pcoms2[i] = pfirst;
          i && (pcom = pcoms2[i - 1]);
        }
        p2[i] = processPath(p2[i], attrs2, pcom);

        if (pcoms2[i] != "A" && pfirst == "C") {
          pcoms2[i] = "C";
        }

        fixArc(p2, i);
      }
      fixM(p, p2, attrs, attrs2, i);
      fixM(p2, p, attrs2, attrs, i);
      var seg = p[i],
          seg2 = p2 && p2[i],
          seglen = seg.length,
          seg2len = p2 && seg2.length;
      attrs.x = seg[seglen - 2];
      attrs.y = seg[seglen - 1];
      attrs.bx = parseFloat(seg[seglen - 4]) || attrs.x;
      attrs.by = parseFloat(seg[seglen - 3]) || attrs.y;
      attrs2.bx = p2 && (parseFloat(seg2[seg2len - 4]) || attrs2.x);
      attrs2.by = p2 && (parseFloat(seg2[seg2len - 3]) || attrs2.y);
      attrs2.x = p2 && seg2[seg2len - 2];
      attrs2.y = p2 && seg2[seg2len - 1];
    }

    return p2 ? [p, p2] : p;
  };

  var box = function box(x, y, width, height) {
    if (x == null) {
      x = y = width = height = 0;
    }
    if (y == null) {
      y = x.y;
      width = x.width;
      height = x.height;
      x = x.x;
    }
    return {
      x: x,
      y: y,
      w: width,
      h: height,
      cx: x + width / 2,
      cy: y + height / 2
    };
  };

  var curveDim = function curveDim(x0, y0, x1, y1, x2, y2, x3, y3) {
    var tvalues = [],
        bounds = [[], []],
        a,
        b,
        c,
        t,
        t1,
        t2,
        b2ac,
        sqrtb2ac;
    for (var i = 0; i < 2; ++i) {
      if (i == 0) {
        b = 6 * x0 - 12 * x1 + 6 * x2;
        a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
        c = 3 * x1 - 3 * x0;
      } else {
        b = 6 * y0 - 12 * y1 + 6 * y2;
        a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
        c = 3 * y1 - 3 * y0;
      }
      if (Math.abs(a) < 1e-12) {
        if (Math.abs(b) < 1e-12) {
          continue;
        }
        t = -c / b;
        if (0 < t && t < 1) {
          tvalues.push(t);
        }
        continue;
      }
      b2ac = b * b - 4 * c * a;
      sqrtb2ac = Math.sqrt(b2ac);
      if (b2ac < 0) {
        continue;
      }
      t1 = (-b + sqrtb2ac) / (2 * a);
      if (0 < t1 && t1 < 1) {
        tvalues.push(t1);
      }
      t2 = (-b - sqrtb2ac) / (2 * a);
      if (0 < t2 && t2 < 1) {
        tvalues.push(t2);
      }
    }

    var x,
        y,
        j = tvalues.length,
        jlen = j,
        mt;
    while (j--) {
      t = tvalues[j];
      mt = 1 - t;
      bounds[0][j] = mt * mt * mt * x0 + 3 * mt * mt * t * x1 + 3 * mt * t * t * x2 + t * t * t * x3;
      bounds[1][j] = mt * mt * mt * y0 + 3 * mt * mt * t * y1 + 3 * mt * t * t * y2 + t * t * t * y3;
    }

    bounds[0][jlen] = x0;
    bounds[1][jlen] = y0;
    bounds[0][jlen + 1] = x3;
    bounds[1][jlen + 1] = y3;
    bounds[0].length = bounds[1].length = jlen + 2;

    return {
      min: { x: Math.min.apply(0, bounds[0]), y: Math.min.apply(0, bounds[1]) },
      max: { x: Math.max.apply(0, bounds[0]), y: Math.max.apply(0, bounds[1]) }
    };
  };

  var curvePathBBox = function curvePathBBox(path) {
    var x = 0,
        y = 0,
        X = [],
        Y = [],
        p;
    for (var i = 0, ii = path.length; i < ii; i++) {
      p = path[i];
      if (p[0] == "M") {
        x = p[1];
        y = p[2];
        X.push(x);
        Y.push(y);
      } else {
        var dim = curveDim(x, y, p[1], p[2], p[3], p[4], p[5], p[6]);
        X = X.concat(dim.min.x, dim.max.x);
        Y = Y.concat(dim.min.y, dim.max.y);
        x = p[5];
        y = p[6];
      }
    }
    var xmin = Math.min.apply(0, X),
        ymin = Math.min.apply(0, Y),
        xmax = Math.max.apply(0, X),
        ymax = Math.max.apply(0, Y),
        bb = box(xmin, ymin, xmax - xmin, ymax - ymin);

    return bb;
  };

  var p2s = /,?([a-z]),?/gi;
  var path2string = function path2string(path) {
    return path.join(',').replace(p2s, "$1");
  };

  var hsrg = { hs: 1, rg: 1 },
      has = "hasOwnProperty",
      colourRegExp = /^\s*((#[a-f\d]{6})|(#[a-f\d]{3})|rgba?\(\s*([\d\.]+%?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+%?(?:\s*,\s*[\d\.]+%?)?)\s*\)|hsba?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?%?)\s*\)|hsla?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?%?)\s*\))\s*$/i,
      commaSpaces = new RegExp("[" + spaces + "]*,[" + spaces + "]*");

  var rgbToString = function rgbToString(rgb) {
    var round = Math.round;
    return "rgba(" + [round(rgb.r), round(rgb.g), round(rgb.b), +rgb.opacity.toFixed(2)] + ")";
  };
  var _toHex = function toHex(color) {
    var i = window.document.getElementsByTagName("head")[0] || window.document.getElementsByTagName("svg")[0],
        red = "rgb(255, 0, 0)";
    _toHex = function toHex(color) {
      if (color.toLowerCase() == "red") {
        return red;
      }
      i.style.color = red;
      i.style.color = color;
      var out = window.document.defaultView.getComputedStyle(i, "").getPropertyValue("color");
      return out == red ? null : out;
    };
    return _toHex(color);
  };

  var packageRGB = function packageRGB(r, g, b, o) {
    r = Math.round(r * 255);
    g = Math.round(g * 255);
    b = Math.round(b * 255);
    var rgb = {
      r: r,
      g: g,
      b: b,
      opacity: isFinite(o) ? o : 1
    };
    return rgb;
  };

  var hsb2rgb = function hsb2rgb(h, s, v, o) {
    if ((typeof h === 'undefined' ? 'undefined' : (0, _typeof3.default)(h)) === (0, _typeof3.default)({}) && "h" in h && "s" in h && "b" in h) {
      v = h.b;
      s = h.s;
      h = h.h;
      o = h.o;
    }
    h *= 360;
    var R, G, B, X, C;
    h = h % 360 / 60;
    C = v * s;
    X = C * (1 - Math.abs(h % 2 - 1));
    R = G = B = v - C;

    h = ~~h;
    R += [C, X, 0, 0, X, C][h];
    G += [X, C, C, X, 0, 0][h];
    B += [0, 0, X, C, C, X][h];
    return packageRGB(R, G, B, o);
  };

  var hsl2rgb = function hsl2rgb(h, s, l, o) {
    if ((typeof h === 'undefined' ? 'undefined' : (0, _typeof3.default)(h)) === (0, _typeof3.default)({}) && "h" in h && "s" in h && "l" in h) {
      l = h.l;
      s = h.s;
      h = h.h;
    }
    if (h > 1 || s > 1 || l > 1) {
      h /= 360;
      s /= 100;
      l /= 100;
    }
    h *= 360;
    var R, G, B, X, C;
    h = h % 360 / 60;
    C = 2 * s * (l < .5 ? l : 1 - l);
    X = C * (1 - Math.abs(h % 2 - 1));
    R = G = B = l - C / 2;

    h = ~~h;
    R += [C, X, 0, 0, X, C][h];
    G += [X, C, C, X, 0, 0][h];
    B += [0, 0, X, C, C, X][h];
    return packageRGB(R, G, B, o);
  };

  var getRGB = function getRGB(colour) {
    if (!colour || !!((colour = String(colour)).indexOf("-") + 1)) {
      return { r: -1, g: -1, b: -1, opacity: -1, error: 1 };
    }
    if (colour == "none") {
      return { r: -1, g: -1, b: -1, opacity: -1 };
    }
    !(hsrg[has](colour.toLowerCase().substring(0, 2)) || colour.charAt() == "#") && (colour = _toHex(colour));
    if (!colour) {
      return { r: -1, g: -1, b: -1, opacity: -1, error: 1 };
    }
    var res,
        red,
        green,
        blue,
        opacity,
        t,
        values,
        rgb = colour.match(colourRegExp);
    if (rgb) {
      if (rgb[2]) {
        blue = parseInt(rgb[2].substring(5), 16);
        green = parseInt(rgb[2].substring(3, 5), 16);
        red = parseInt(rgb[2].substring(1, 3), 16);
      }
      if (rgb[3]) {
        blue = parseInt((t = rgb[3].charAt(3)) + t, 16);
        green = parseInt((t = rgb[3].charAt(2)) + t, 16);
        red = parseInt((t = rgb[3].charAt(1)) + t, 16);
      }
      if (rgb[4]) {
        values = rgb[4].split(commaSpaces);
        red = parseFloat(values[0]);
        values[0].slice(-1) == "%" && (red *= 2.55);
        green = parseFloat(values[1]);
        values[1].slice(-1) == "%" && (green *= 2.55);
        blue = parseFloat(values[2]);
        values[2].slice(-1) == "%" && (blue *= 2.55);
        rgb[1].toLowerCase().slice(0, 4) == "rgba" && (opacity = parseFloat(values[3]));
        values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
      }
      if (rgb[5]) {
        values = rgb[5].split(commaSpaces);
        red = parseFloat(values[0]);
        values[0].slice(-1) == "%" && (red /= 100);
        green = parseFloat(values[1]);
        values[1].slice(-1) == "%" && (green /= 100);
        blue = parseFloat(values[2]);
        values[2].slice(-1) == "%" && (blue /= 100);
        (values[0].slice(-3) == "deg" || values[0].slice(-1) == "\xb0") && (red /= 360);
        rgb[1].toLowerCase().slice(0, 4) == "hsba" && (opacity = parseFloat(values[3]));
        values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
        return hsb2rgb(red, green, blue, opacity);
      }
      if (rgb[6]) {
        values = rgb[6].split(commaSpaces);
        red = parseFloat(values[0]);
        values[0].slice(-1) == "%" && (red /= 100);
        green = parseFloat(values[1]);
        values[1].slice(-1) == "%" && (green /= 100);
        blue = parseFloat(values[2]);
        values[2].slice(-1) == "%" && (blue /= 100);
        (values[0].slice(-3) == "deg" || values[0].slice(-1) == "\xb0") && (red /= 360);
        rgb[1].toLowerCase().slice(0, 4) == "hsla" && (opacity = parseFloat(values[3]));
        values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
        return hsl2rgb(red, green, blue, opacity);
      }
      red = Math.min(Math.round(red), 255);
      green = Math.min(Math.round(green), 255);
      blue = Math.min(Math.round(blue), 255);
      opacity = Math.min(Math.max(opacity, 0), 1);
      rgb = { r: red, g: green, b: blue };
      rgb.opacity = isFinite(opacity) ? opacity : 1;
      return rgb;
    }
    return { r: -1, g: -1, b: -1, opacity: -1, error: 1 };
  };

  function SVGMorpheus(element, options, callback) {
    if (!element) {
      throw new Error('SVGMorpheus > "element" is required');
    }

    if ((typeof element === 'undefined' ? 'undefined' : (0, _typeof3.default)(element)) === (0, _typeof3.default)('')) {
      element = document.querySelector(element);
      if (!element) {
        throw new Error('SVGMorpheus > "element" query is not related to an existing DOM node');
      }
    }

    if (!!options && (typeof options === 'undefined' ? 'undefined' : (0, _typeof3.default)(options)) !== (0, _typeof3.default)({})) {
      throw new Error('SVGMorpheus > "options" parameter must be an object');
    }
    options = options || {};

    if (!!callback && (typeof callback === 'undefined' ? 'undefined' : (0, _typeof3.default)(callback)) !== (0, _typeof3.default)(function () {})) {
      throw new Error('SVGMorpheus > "callback" parameter must be a function');
    }

    var that = this;

    this._icons = {};
    this._curIconId = options.iconId || '';
    this._toIconId = '';
    this._curIconItems = [];
    this._fromIconItems = [];
    this._toIconItems = [];
    this._morphNodes = [];
    this._morphG;
    this._startTime;
    this._defDuration = options.duration || 750;
    this._defEasing = options.easing || 'quad-in-out';
    this._defRotation = options.rotation || 'clock';
    this._defCallback = callback || function () {};
    this._duration = this._defDuration;
    this._easing = this._defEasing;
    this._rotation = this._defRotation;
    this._callback = this._defCallback;
    this._rafid;

    this._fnTick = function (timePassed) {
      if (!that._startTime) {
        that._startTime = timePassed;
      }
      var progress = Math.min((timePassed - that._startTime) / that._duration, 1);
      that._updateAnimationProgress(progress);
      if (progress < 1) {
        that._rafid = _reqAnimFrame(that._fnTick);
      } else {
        if (that._toIconId != '') {
          that._animationEnd();
        }
      }
    };

    if (element.nodeName.toUpperCase() === 'SVG') {
      this._svgDoc = element;
    } else {
      this._svgDoc = element.getSVGDocument();
    }
    if (!this._svgDoc) {
      element.addEventListener("load", function () {
        that._svgDoc = element.getSVGDocument();
        that._init();
      }, false);
    } else {
      that._init();
    }
  }

  SVGMorpheus.prototype._init = function () {
    if (this._svgDoc.nodeName.toUpperCase() !== 'SVG') {
      this._svgDoc = this._svgDoc.getElementsByTagName('svg')[0];
    }

    if (!!this._svgDoc) {
      var lastIconId = '',
          i,
          len,
          id,
          items,
          item,
          j,
          len2,
          icon;

      for (i = this._svgDoc.childNodes.length - 1; i >= 0; i--) {
        var nodeIcon = this._svgDoc.childNodes[i];
        if (nodeIcon.nodeName.toUpperCase() === 'G') {
          id = nodeIcon.getAttribute('id');
          if (!!id) {
            items = [];
            for (j = 0, len2 = nodeIcon.childNodes.length; j < len2; j++) {
              var nodeItem = nodeIcon.childNodes[j];
              item = {
                path: '',
                attrs: {},
                style: {}
              };

              switch (nodeItem.nodeName.toUpperCase()) {
                case 'PATH':
                  item.path = nodeItem.getAttribute('d');
                  break;
                case 'CIRCLE':
                  var cx = nodeItem.getAttribute('cx') * 1,
                      cy = nodeItem.getAttribute('cy') * 1,
                      r = nodeItem.getAttribute('r') * 1;
                  item.path = 'M' + (cx - r) + ',' + cy + 'a' + r + ',' + r + ' 0 1,0 ' + r * 2 + ',0a' + r + ',' + r + ' 0 1,0 -' + r * 2 + ',0z';
                  break;
                case 'ELLIPSE':
                  var cx = nodeItem.getAttribute('cx') * 1,
                      cy = nodeItem.getAttribute('cy') * 1,
                      rx = nodeItem.getAttribute('rx') * 1,
                      ry = nodeItem.getAttribute('ry') * 1;
                  item.path = 'M' + (cx - rx) + ',' + cy + 'a' + rx + ',' + ry + ' 0 1,0 ' + rx * 2 + ',0a' + rx + ',' + ry + ' 0 1,0 -' + rx * 2 + ',0z';
                  break;
                case 'RECT':
                  var x = nodeItem.getAttribute('x') * 1,
                      y = nodeItem.getAttribute('y') * 1,
                      w = nodeItem.getAttribute('width') * 1,
                      h = nodeItem.getAttribute('height') * 1,
                      rx = nodeItem.getAttribute('rx') * 1,
                      ry = nodeItem.getAttribute('ry') * 1;
                  if (!rx && !ry) {
                    item.path = 'M' + x + ',' + y + 'l' + w + ',0l0,' + h + 'l-' + w + ',0z';
                  } else {
                    item.path = 'M' + (x + rx) + ',' + y + 'l' + (w - rx * 2) + ',0' + 'a' + rx + ',' + ry + ' 0 0,1 ' + rx + ',' + ry + 'l0,' + (h - ry * 2) + 'a' + rx + ',' + ry + ' 0 0,1 -' + rx + ',' + ry + 'l' + (rx * 2 - w) + ',0' + 'a' + rx + ',' + ry + ' 0 0,1 -' + rx + ',-' + ry + 'l0,' + (ry * 2 - h) + 'a' + rx + ',' + ry + ' 0 0,1 ' + rx + ',-' + ry + 'z';
                  }
                  break;
                case 'POLYGON':
                  var points = nodeItem.getAttribute('points');
                  var p = points.split(/\s+/);
                  var path = "";
                  for (var k = 0, len = p.length; k < len; k++) {
                    path += (k && "L" || "M") + p[k];
                  }
                  item.path = path + 'z';
                  break;
                case 'LINE':
                  var x1 = nodeItem.getAttribute('x1') * 1,
                      y1 = nodeItem.getAttribute('y1') * 1,
                      x2 = nodeItem.getAttribute('x2') * 1,
                      y2 = nodeItem.getAttribute('y2') * 1;
                  item.path = 'M' + x1 + ',' + y1 + 'L' + x2 + ',' + y2 + 'z';
                  break;
              }
              if (item.path != '') {
                for (var k = 0, len3 = nodeItem.attributes.length; k < len3; k++) {
                  var attrib = nodeItem.attributes[k];
                  if (attrib.specified) {
                    var name = attrib.name.toLowerCase();
                    switch (name) {
                      case 'fill':
                      case 'fill-opacity':
                      case 'opacity':
                      case 'stroke':
                      case 'stroke-opacity':
                      case 'stroke-width':
                        item.attrs[name] = attrib.value;
                    }
                  }
                }

                for (var l = 0, len4 = nodeItem.style.length; l < len4; l++) {
                  var styleName = nodeItem.style[l];
                  switch (styleName) {
                    case 'fill':
                    case 'fill-opacity':
                    case 'opacity':
                    case 'stroke':
                    case 'stroke-opacity':
                    case 'stroke-width':
                      item.style[styleName] = nodeItem.style[styleName];
                  }
                }

                items.push(item);
              }
            }

            if (items.length > 0) {
              icon = {
                id: id,
                items: items
              };
              this._icons[id] = icon;
            }

            if (!this._morphG) {
              lastIconId = id;
              this._morphG = document.createElementNS('http://www.w3.org/2000/svg', 'g');
              this._svgDoc.replaceChild(this._morphG, nodeIcon);
            } else {
              this._svgDoc.removeChild(nodeIcon);
            }
          }
        }
      }

      var defaultIcon = this._curIconId || lastIconId;
      if (defaultIcon !== '') {
        this._setupAnimation(defaultIcon);
        this._updateAnimationProgress(1);
        this._animationEnd();
      }
    }
  };

  SVGMorpheus.prototype._setupAnimation = function (toIconId) {
    if (!!toIconId && !!this._icons[toIconId]) {
      this._toIconId = toIconId;
      this._startTime = undefined;
      var i, len, j, len2;
      this._fromIconItems = clone(this._curIconItems);
      this._toIconItems = clone(this._icons[toIconId].items);

      for (i = 0, len = this._morphNodes.length; i < len; i++) {
        var morphNode = this._morphNodes[i];
        morphNode.fromIconItemIdx = i;
        morphNode.toIconItemIdx = i;
      }

      var maxNum = Math.max(this._fromIconItems.length, this._toIconItems.length);
      var toBB;
      for (i = 0; i < maxNum; i++) {
        if (!this._fromIconItems[i]) {
          if (!!this._toIconItems[i]) {
            toBB = curvePathBBox(path2curve(this._toIconItems[i].path));
            this._fromIconItems.push({
              path: 'M' + toBB.cx + ',' + toBB.cy + 'l0,0',
              attrs: {},
              style: {},
              trans: {
                'rotate': [0, toBB.cx, toBB.cy]
              }
            });
          } else {
            this._fromIconItems.push({
              path: 'M0,0l0,0',
              attrs: {},
              style: {},
              trans: {
                'rotate': [0, 0, 0]
              }
            });
          }
        }
        if (!this._toIconItems[i]) {
          if (!!this._fromIconItems[i]) {
            toBB = curvePathBBox(path2curve(this._fromIconItems[i].path));
            this._toIconItems.push({
              path: 'M' + toBB.cx + ',' + toBB.cy + 'l0,0',
              attrs: {},
              style: {},
              trans: {
                'rotate': [0, toBB.cx, toBB.cy]
              }
            });
          } else {
            this._toIconItems.push({
              path: 'M0,0l0,0',
              attrs: {},
              style: {},
              trans: {
                'rotate': [0, 0, 0]
              }
            });
          }
        }

        if (!this._morphNodes[i]) {
          var node = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          this._morphG.appendChild(node);
          this._morphNodes.push({
            node: node,
            fromIconItemIdx: i,
            toIconItemIdx: i
          });
        }
      }

      for (i = 0; i < maxNum; i++) {
        var fromIconItem = this._fromIconItems[i];
        var toIconItem = this._toIconItems[i];

        var curves = path2curve(this._fromIconItems[i].path, this._toIconItems[i].path);
        fromIconItem.curve = curves[0];
        toIconItem.curve = curves[1];

        var attrsNorm = styleToNorm(this._fromIconItems[i].attrs, this._toIconItems[i].attrs);
        fromIconItem.attrsNorm = attrsNorm[0];
        toIconItem.attrsNorm = attrsNorm[1];
        fromIconItem.attrs = styleNormToString(fromIconItem.attrsNorm);
        toIconItem.attrs = styleNormToString(toIconItem.attrsNorm);

        var styleNorm = styleToNorm(this._fromIconItems[i].style, this._toIconItems[i].style);
        fromIconItem.styleNorm = styleNorm[0];
        toIconItem.styleNorm = styleNorm[1];
        fromIconItem.style = styleNormToString(fromIconItem.styleNorm);
        toIconItem.style = styleNormToString(toIconItem.styleNorm);

        toBB = curvePathBBox(toIconItem.curve);
        toIconItem.trans = {
          'rotate': [0, toBB.cx, toBB.cy]
        };
        var rotation = this._rotation,
            degAdd;
        if (rotation === 'random') {
          rotation = Math.random() < 0.5 ? 'counterclock' : 'clock';
        }
        switch (rotation) {
          case 'none':
            if (!!fromIconItem.trans.rotate) {
              toIconItem.trans.rotate[0] = fromIconItem.trans.rotate[0];
            }
            break;
          case 'counterclock':
            if (!!fromIconItem.trans.rotate) {
              toIconItem.trans.rotate[0] = fromIconItem.trans.rotate[0] - 360;
              degAdd = -fromIconItem.trans.rotate[0] % 360;
              toIconItem.trans.rotate[0] += degAdd < 180 ? degAdd : degAdd - 360;
            } else {
              toIconItem.trans.rotate[0] = -360;
            }
            break;
          default:
            if (!!fromIconItem.trans.rotate) {
              toIconItem.trans.rotate[0] = fromIconItem.trans.rotate[0] + 360;
              degAdd = fromIconItem.trans.rotate[0] % 360;
              toIconItem.trans.rotate[0] += degAdd < 180 ? -degAdd : 360 - degAdd;
            } else {
              toIconItem.trans.rotate[0] = 360;
            }
            break;
        }
      }

      this._curIconItems = clone(this._fromIconItems);
    }
  };

  SVGMorpheus.prototype._updateAnimationProgress = function (progress) {
    progress = easings[this._easing](progress);

    var i, j, k, len;

    for (i = 0, len = this._curIconItems.length; i < len; i++) {
      this._curIconItems[i].curve = curveCalc(this._fromIconItems[i].curve, this._toIconItems[i].curve, progress);
      this._curIconItems[i].path = path2string(this._curIconItems[i].curve);

      this._curIconItems[i].attrsNorm = styleNormCalc(this._fromIconItems[i].attrsNorm, this._toIconItems[i].attrsNorm, progress);
      this._curIconItems[i].attrs = styleNormToString(this._curIconItems[i].attrsNorm);

      this._curIconItems[i].styleNorm = styleNormCalc(this._fromIconItems[i].styleNorm, this._toIconItems[i].styleNorm, progress);
      this._curIconItems[i].style = styleNormToString(this._curIconItems[i].styleNorm);

      this._curIconItems[i].trans = transCalc(this._fromIconItems[i].trans, this._toIconItems[i].trans, progress);
      this._curIconItems[i].transStr = trans2string(this._curIconItems[i].trans);
    }

    for (i = 0, len = this._morphNodes.length; i < len; i++) {
      var morphNode = this._morphNodes[i];
      morphNode.node.setAttribute("d", this._curIconItems[i].path);
      var attrs = this._curIconItems[i].attrs;
      for (j in attrs) {
        morphNode.node.setAttribute(j, attrs[j]);
      }
      var style = this._curIconItems[i].style;
      for (k in style) {
        morphNode.node.style[k] = style[k];
      }
      morphNode.node.setAttribute("transform", this._curIconItems[i].transStr);
    }
  };

  SVGMorpheus.prototype._animationEnd = function () {
    for (var i = this._morphNodes.length - 1; i >= 0; i--) {
      var morphNode = this._morphNodes[i];
      if (!!this._icons[this._toIconId].items[i]) {
        morphNode.node.setAttribute("d", this._icons[this._toIconId].items[i].path);
      } else {
        morphNode.node.parentNode.removeChild(morphNode.node);
        this._morphNodes.splice(i, 1);
      }
    }

    this._curIconId = this._toIconId;
    this._toIconId = '';

    this._callback();
  };

  SVGMorpheus.prototype.to = function (iconId, options, callback) {
    if (iconId !== this._toIconId) {
      if (!!options && (typeof options === 'undefined' ? 'undefined' : (0, _typeof3.default)(options)) !== (0, _typeof3.default)({})) {
        throw new Error('SVGMorpheus.to() > "options" parameter must be an object');
      }
      options = options || {};

      if (!!callback && (typeof callback === 'undefined' ? 'undefined' : (0, _typeof3.default)(callback)) !== (0, _typeof3.default)(function () {})) {
        throw new Error('SVGMorpheus.to() > "callback" parameter must be a function');
      }

      _cancelAnimFrame(this._rafid);

      this._duration = options.duration || this._defDuration;
      this._easing = options.easing || this._defEasing;
      this._rotation = options.rotation || this._defRotation;
      this._callback = callback || this._defCallback;

      this._setupAnimation(iconId);
      this._rafid = _reqAnimFrame(this._fnTick);
    }
  };

  SVGMorpheus.prototype.registerEasing = function (name, fn) {
    easings[name] = fn;
  };

  return SVGMorpheus;
}();

exports.default = SVGMorpheus;

/***/ }),

/***/ "6S4q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'Intro',
  data: function data() {
    return {
      titleAnimation: false,
      nameAnimation: false,
      logoAnimation: false
    };
  },
  methods: {
    afterVideo: function afterVideo(el) {
      var self = this;
      setTimeout(function () {
        self.logoAnimation = true;
      }, 1000);
      setTimeout(function () {
        self.titleAnimation = true;
      }, 1500);
      setTimeout(function () {
        self.nameAnimation = true;
      }, 2000);
    }
  }
};

/***/ }),

/***/ "8+ix":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('background-animation'),_vm._v(" "),_c('main',{class:{home: _vm.routeName === 'home'}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1),_vm._v(" "),_c('page-footer'),_vm._v(" "),_c('vue-progress-bar'),_vm._v(" "),_c('page-header')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "89FK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _svgMorpheus = __webpack_require__("61mf");

var _svgMorpheus2 = _interopRequireDefault(_svgMorpheus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Background',
  data: function data() {
    return {
      myIcon: null,
      target: this.$route.name,
      bgRatio: 'xMidYMid',
      bgList: [{
        name: 'home',
        path: ["M-82.6,397c0-97.4,0-248.1,0-314c36.9,0,84.7,0,118.2,0c0,41.6,0,256.7,0,314C1.1,397-49.7,397-82.6,397z", "M684.4,397c0-97.4,0-248.1,0-314c36.9,0,84.7,0,118.2,0c0,41.6,0,256.7,0,314C768.1,397,717.3,397,684.4,397z"],
        mobile: ["M-95.1,509c0-120,0-305.8,0-387c36.9,0,84.7,0,118.2,0c0,51.3,0,316.4,0,387C-11.4,509-62.2,509-95.1,509z", "M456.9,509c0-120,0-305.8,0-387c36.9,0,84.7,0,118.2,0c0,51.3,0,316.4,0,387C540.6,509,489.8,509,456.9,509z"]
      }, {
        name: 'about',
        path: ["M-0.3-217.4C39.9-177.1,192.8-29,220.1-1.8C151.6,66.5,62,155.1-0.3,217.4c-17.2-17.2-196-195.5-219.7-219.1 C-156.1-65.8-61.5-156.1-0.3-217.4z", "M719.7,262.6C759.9,302.9,912.8,451,940,478.2C871.7,546.5,782,635,719.7,697.3c-17.2-17.2-196-195.4-219.7-219.1 C564,414.2,658.5,323.9,719.7,262.6z"],
        mobile: ["M22.2-137.9C-11.6-104.1-89-26.7-139,23.3c38.6,38.6,98.2,98.2,138.7,138.7C29.1,132.5,139.5,22.1,160.9,0.7 C121.6-38.6,65.5-94.7,22.2-137.9", "M480.2,559.1C446.4,592.9,369,670.3,319,720.3c38.6,38.6,98.2,98.2,138.7,138.7c29.4-29.4,139.9-139.9,161.2-161.2 C579.6,658.4,523.5,602.3,480.2,559.1z"]
      }, {
        name: 'project',
        path: ["M0,480C0,331.1,0,100.7,0,0c224.8,0,515.9,0,720,0c0,63.6,0,392.4,0,480C509.8,480,200.4,480,0,480z"],
        mobile: ["M0,720C0,526.1,0,226.2,0,95c149.8,0,344,0,480,0c0,82.8,0,510.9,0,625C339.9,720,133.6,720,0,720z"]
      }, {
        name: 'contact',
        path: ["M-271.3,467c56.7-104.2,144.6-265.4,183-336c207,112.8,475.8,259.2,664.5,361.9c-24.2,44.5-149.6,274.7-183,336 C199.5,723.5-86,568-271.3,467z"],
        mobile: ["M-155,663.5C-110.8,587.4-42.2,469.6-12.3,418C149.2,500.4,358.8,607.4,506,682.5C487.1,715,389.3,883.2,363.3,928 C212.2,851-10.5,737.3-155,663.5z"]
      }, {
        name: 'error',
        path: ["M214,372.5c0-87.7,0-223.2,0-282.5c91,0,209.3,0,292,0c0,37.5,0,230.9,0,282.5C420.8,372.5,295.3,372.5,214,372.5z"],
        mobile: ["M53,400.5c0-87.7,0-223.2,0-282.5c116.6,0,268.1,0,374,0c0,37.5,0,230.9,0,282.5C317.9,400.5,157.1,400.5,53,400.5z"]
      }]
    };
  },
  methods: {
    tween: function tween() {
      this.myIcon.to(this.target);
    }
  },
  mounted: function mounted() {
    this.myIcon = new _svgMorpheus2.default('#background-svg');
    this.target = this.routeName;
    this.tween();
  },
  watch: {
    '$route': function $route(to, from) {
      if (to.params.url === undefined || 'eventor' && from.params.url === undefined) {
        this.target = this.routeName;
        this.tween();
      }
    }
  }
};

/***/ }),

/***/ "8weS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueCarousel = __webpack_require__("/kJX");

exports.default = {
  name: 'ProjectGallery',
  props: ['projectId', 'list'],
  data: function data() {
    return {};
  },
  components: {
    Carousel: _vueCarousel.Carousel,
    Slide: _vueCarousel.Slide
  }
};

/***/ }),

/***/ "93nI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/floorplan.b7b9a32.jpg";

/***/ }),

/***/ "9p8q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c('transition-group',{attrs:{"tag":"ul","name":"navAnimation","appear":"","appear-active-class":"nav-anmation","itemscope":"","itemtype":"http://www.schema.org/SiteNavigationElement"}},[_vm._l((_vm.list),function(item,index){return _c('li',{key:index,attrs:{"itemprop":"name"}},[_c('router-link',{class:item.name,attrs:{"to":item.url,"itemprop":"url"}},[_vm._v(_vm._s(item.name)+_vm._s(item.index))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.caption))])],1)}),_vm._v(" "),_c('li',{key:5,attrs:{"itemprop":"name"}},[_c('a',{attrs:{"href":"https://blog.256pages.com","itemprop":"url"}},[_vm._v("blog")]),_vm._v(" "),_c('span',[_vm._v("my development blog")])])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9uml":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A418":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bookmark2.b340b21.jpg";

/***/ }),

/***/ "AliK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BBC3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutSkills_vue__ = __webpack_require__("KHkB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutSkills_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutSkills_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutSkills_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutSkills_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_145d0406_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutSkills_vue__ = __webpack_require__("vu0j");
function injectStyle (ssrContext) {
  __webpack_require__("jzfu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-145d0406"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutSkills_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_145d0406_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutSkills_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "C7MC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/score.95062ed.png";

/***/ }),

/***/ "CNFm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectGallery_vue__ = __webpack_require__("8weS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectGallery_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectGallery_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectGallery_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectGallery_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53edb00e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectGallery_vue__ = __webpack_require__("GtgL");
function injectStyle (ssrContext) {
  __webpack_require__("lQpg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53edb00e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectGallery_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53edb00e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectGallery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "D91m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectList_vue__ = __webpack_require__("YUz1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectList_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectList_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectList_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05e052a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectList_vue__ = __webpack_require__("L72Z");
function injectStyle (ssrContext) {
  __webpack_require__("xXGj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05e052a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectList_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05e052a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "DpCX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/test.591bfd6.jpg";

/***/ }),

/***/ "E+Rs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'About256'
};

/***/ }),

/***/ "EAr1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageIndex_vue__ = __webpack_require__("y+Dm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageIndex_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageIndex_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageIndex_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageIndex_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff6ab65e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageIndex_vue__ = __webpack_require__("lWha");
function injectStyle (ssrContext) {
  __webpack_require__("AliK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ff6ab65e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageIndex_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff6ab65e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageIndex_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "EjA0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/propic-line.822294e.png";

/***/ }),

/***/ "G/Zm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bookmark.d457e7c.jpg";

/***/ }),

/***/ "G6WW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _svgMorpheus = __webpack_require__("61mf");

var _svgMorpheus2 = _interopRequireDefault(_svgMorpheus);

var _PageNavbar = __webpack_require__("fY3Y");

var _PageNavbar2 = _interopRequireDefault(_PageNavbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Header',
  data: function data() {
    return {
      tab: null,
      navOpen: false,
      scrolled: false
    };
  },
  methods: {
    tween: function tween(target) {
      this.tab.to(target);
    },
    scrollPoisition: function scrollPoisition() {
      this.scrolled = window.scrollY > 0;
    }
  },
  mounted: function mounted() {
    this.tab = new _svgMorpheus2.default('#mobile-btn', {
      duration: 300
    });
  },
  created: function created() {
    window.addEventListener('scroll', this.scrollPoisition);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.scrollPoisition);
  },
  components: {
    Navbar: _PageNavbar2.default
  },
  watch: {
    navOpen: function navOpen() {
      if (this.navOpen === false) {
        this.tween('open');
      } else {
        this.tween('close');
      }
    },
    '$route': function $route(to, from) {
      if (to.params.url === undefined || 'eventor' && from.params.url === undefined) {
        this.tween('open');
        this.navOpen = false;
      }
    }
  }
};

/***/ }),

/***/ "GWQV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cover.2eb333d.jpg";

/***/ }),

/***/ "GtgL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('carousel',{attrs:{"paginationActiveColor":"#42b983","paginationColor":"#ffffff","speed":300,"easing":"ease","perPage":1,"paginationSize":5}},_vm._l((_vm.list[_vm.projectId].gallery),function(img){return _c('slide',{key:img.id},[_c('img',{attrs:{"src":__webpack_require__("Hnub")("./" + _vm.list[_vm.projectId].path + '/' + img.fileName),"alt":_vm.list[_vm.projectId].name + img.title}})])}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HDeu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner2.5f8d661.jpg";

/***/ }),

/***/ "HjJ8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner1.aafc6b2.jpg";

/***/ }),

/***/ "Hnub":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./canon/cover.jpg": "QCjM",
	"./canon/main.jpg": "OGOT",
	"./canon/ux.jpg": "uwKF",
	"./chinese-fonts/cover.jpg": "O0To",
	"./cloudnifier/cover.jpg": "vv4A",
	"./disenyland/cover.jpg": "GWQV",
	"./drawing/pinky.jpg": "Lazi",
	"./drawing/propic-line.png": "EjA0",
	"./drawing/propic.png": "ffvQ",
	"./dtc/dashboard.jpg": "kxZM",
	"./dtc/project.jpg": "mgRi",
	"./eventor/banner1.jpg": "HjJ8",
	"./eventor/banner2.jpg": "HDeu",
	"./eventor/ux.jpg": "wgy/",
	"./glassesgallery/content.jpg": "5FwO",
	"./glassesgallery/cover.jpg": "OL8e",
	"./glassesgallery/list.jpg": "MhaO",
	"./hatchya/banner.jpg": "M95u",
	"./hatchya/card.jpg": "149w",
	"./hatchya/infographic.jpg": "ttFu",
	"./hatchya/infographic2.jpg": "1h50",
	"./hatchya/login.jpg": "gYFG",
	"./management/dashboard.jpg": "lRq9",
	"./management/floorplan.jpg": "93nI",
	"./management/login.jpg": "iZYo",
	"./management/request.jpg": "hnXK",
	"./merchant-plus/collection.jpg": "iNIn",
	"./merchant-plus/collection2.jpg": "KdqL",
	"./merchant-plus/login.jpg": "djIF",
	"./merchant-plus/mobile.jpg": "gJL2",
	"./student-smart/bookmark.jpg": "G/Zm",
	"./student-smart/bookmark2.jpg": "A418",
	"./student-smart/circle.png": "qgFt",
	"./student-smart/comment.png": "tQKA",
	"./student-smart/profile.png": "X/Eb",
	"./student-smart/score.png": "C7MC",
	"./student-smart/student.png": "bqfK",
	"./svg-morpheus/cover.jpg": "cUoY",
	"./swisscoat/blog.jpg": "kNH2",
	"./swisscoat/index.jpg": "bwqR",
	"./swisscoat/lens.jpg": "JJb3",
	"./swisscoat/sim.jpg": "UcYB",
	"./swisscoat/test.jpg": "DpCX",
	"./vtour/VTour01.png": "OjpB",
	"./vtour/home.png": "0lwl"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Hnub";

/***/ }),

/***/ "IyKG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactGuestbook_vue__ = __webpack_require__("0CHp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactGuestbook_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactGuestbook_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactGuestbook_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactGuestbook_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_712c01f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactGuestbook_vue__ = __webpack_require__("d7qu");
function injectStyle (ssrContext) {
  __webpack_require__("skdO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-712c01f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactGuestbook_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_712c01f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactGuestbook_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "JJb3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lens.1a7aec2.jpg";

/***/ }),

/***/ "KHkB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _scrollmonitor = __webpack_require__("E1Rp");

var _scrollmonitor2 = _interopRequireDefault(_scrollmonitor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'AboutMe',
  data: function data() {
    return {
      loadBar: false,
      skills: [{
        name: 'User Experience Design',
        percent: 75
      }, {
        name: 'Graphic Design',
        percent: 85
      }, {
        name: 'Search Engine Optimization',
        percent: 90
      }, {
        name: 'Solution Consultancy',
        percent: 70
      }, {
        name: 'Web Front-end Development',
        percent: 95
      }, {
        name: 'API Development',
        percent: 75
      }, {
        name: 'Project Management',
        percent: 70
      }]
    };
  },
  mounted: function mounted() {
    var self = this;
    var checkSkill = document.getElementsByClassName("skill-bar");
    var skillWatcher = _scrollmonitor2.default.create(checkSkill);
    skillWatcher.fullyEnterViewport(function () {
      self.loadBar = true;
    });
    skillWatcher.partiallyExitViewport(function () {
      self.loadBar = false;
    });
  }
};

/***/ }),

/***/ "KdqL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/collection2.2f12656.jpg";

/***/ }),

/***/ "L72Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('project-timeline',{attrs:{"projectId":_vm.projectId}},_vm._l((_vm.list),function(project){return _c('li',{key:project.id},[_c('router-link',{attrs:{"to":{ name: 'project', params: {url: project.path}}},nativeOn:{"click":function($event){_vm.updateProject(project.id)}}},[(project.id <= 9)?_vm._t("default",[_vm._v("0")]):_vm._e(),_vm._v(_vm._s(project.id)+"\n      ")],2)],1)})),_vm._v(" "),_c('section',{staticClass:"container"},[_c('project-info',{class:{load: _vm.loading === true},attrs:{"project-id":_vm.projectId,"list":_vm.list}}),_vm._v(" "),_c('project-gallery',{class:{load: _vm.loading === true},attrs:{"project-id":_vm.projectId,"list":_vm.list}})],1),_vm._v(" "),_c('div',{staticClass:"back btn",class:{disabled: _vm.projectId < 1},on:{"click":function($event){_vm.backProject()}}},[_c('svg',{attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 17.5 25.6","xml:space":"preserve"}},[_c('polygon',{attrs:{"points":"17.5,4.7 12.8,0 0,12.8 12.8,25.6 17.5,20.9 9.4,12.8 "}})])]),_vm._v(" "),_c('div',{staticClass:"next btn",class:{disabled: _vm.projectId === (_vm.list.length - 1)},on:{"click":function($event){_vm.nextProject()}}},[_c('svg',{attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 17.5 25.6","xml:space":"preserve"}},[_c('polygon',{attrs:{"points":"17.5,4.7 12.8,0 0,12.8 12.8,25.6 17.5,20.9 9.4,12.8 "}})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Lazi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pinky.f408412.jpg";

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91a45558_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("8+ix");
function injectStyle (ssrContext) {
  __webpack_require__("VgDp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-91a45558"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91a45558_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "M95u":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner.d976c4f.jpg";

/***/ }),

/***/ "MhaO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/list.5c58b83.jpg";

/***/ }),

/***/ "O0To":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cover.5a6be8a.jpg";

/***/ }),

/***/ "OGOT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/main.c029034.jpg";

/***/ }),

/***/ "OL8e":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cover.ae56040.jpg";

/***/ }),

/***/ "OOQz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'Navbar',
  data: function data() {
    return {
      list: [{
        name: 'home',
        url: '/',
        caption: 'welcome to my website'
      }, {
        name: 'about',
        url: '/about',
        caption: 'something about me'
      }, {
        name: 'projects',
        url: '/projects',
        caption: 'my projects'
      }, {
        name: 'contact',
        url: '/contact',
        caption: 'if you want to find me'
      }]
    };
  }
};

/***/ }),

/***/ "ORkw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OjpB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/VTour01.64cf824.png";

/***/ }),

/***/ "P7HO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[_c('h2',[_vm._v("About me")]),_vm._v(" "),_c('p',[_vm._v("Hi, i am a designer from Hong Kong. As my position is a full stack designer, that's mean i can design from graphic to user experience, also the front-end programming. ")]),_vm._v(" "),_c('p',[_vm._v("When I design website UI for coder at the beginning, but they always create website exactly not i want. So I try to build it myself, from CSS / HTML to jquery.")]),_vm._v(" "),_c('p',[_vm._v("But jquery still have limitation. Performance problems and only can run at front-end, so i learn some php for layout templating")]),_vm._v(" "),_c('p',[_vm._v("After try to build some website with javascript frameworks. I think this is the way i want to extend. I build this website with full javascript framework, also with REST API for contact form.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QCjM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cover.12c8c81.jpg";

/***/ }),

/***/ "QZV/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexVideo_vue__ = __webpack_require__("6S4q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexVideo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexVideo_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexVideo_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexVideo_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a88ec3c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndexVideo_vue__ = __webpack_require__("2yqe");
function injectStyle (ssrContext) {
  __webpack_require__("mEwG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a88ec3c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexVideo_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a88ec3c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndexVideo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "RPYb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ContactGuestbook = __webpack_require__("IyKG");

var _ContactGuestbook2 = _interopRequireDefault(_ContactGuestbook);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Contact',
  metaInfo: {
    title: "Contact Edmond",
    meta: [{
      vmid: 'description',
      name: 'description',
      content: "Contact Edmond if you want to have more information."
    }]
  },
  components: {
    GuestBook: _ContactGuestbook2.default
  }
};

/***/ }),

/***/ "T0ue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-tag"},[_c('router-link',{class:{hide: this.routeName === 'home'},attrs:{"to":"/"}},[_vm._v("弐")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T2l3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TuCX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tz0M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('span',[(_vm.projectId <= 9)?_vm._t("default",[_vm._v("0")]):_vm._e(),_vm._v(_vm._s(_vm.projectId + 1))],2),_vm._v(" "),_c('div',{staticClass:"block",style:({background: _vm.list[_vm.projectId].themeColor})}),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.list[_vm.projectId].name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.list[_vm.projectId].description))]),_vm._v(" "),_c('project-type',_vm._l((_vm.list[_vm.projectId].typeList),function(type){return _c('li',{key:type.id},[_vm._v(_vm._s(type))])}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UcYB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sim.c8d799f.jpg";

/***/ }),

/***/ "V3qm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageBackground_vue__ = __webpack_require__("89FK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageBackground_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageBackground_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageBackground_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageBackground_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56cec924_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageBackground_vue__ = __webpack_require__("fZ15");
function injectStyle (ssrContext) {
  __webpack_require__("eljf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageBackground_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56cec924_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageBackground_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Vg2l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('button',{on:{"click":function($event){_vm.loadApi()}}},[_vm._v("Refresh")]),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.delCm()}}},[_vm._v("Delete")]),_vm._v(" "),_vm._l((_vm.comments),function(comment){return _c('li',{key:comment.id},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedCm),expression:"checkedCm"}],attrs:{"type":"checkbox"},domProps:{"value":comment._id,"checked":Array.isArray(_vm.checkedCm)?_vm._i(_vm.checkedCm,comment._id)>-1:(_vm.checkedCm)},on:{"change":function($event){var $$a=_vm.checkedCm,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=comment._id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkedCm=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkedCm=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checkedCm=$$c}}}}),_vm._v(" "),_c('h2',[_c('a',{attrs:{"href":'mailto:' + comment.email}},[_vm._v(_vm._s(comment.name))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(comment.content))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.timeCheck(comment.createdAt)))])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VgDp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X/Eb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/profile.91ca949.png";

/***/ }),

/***/ "XWXL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YUz1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _projects = __webpack_require__("+aM5");

var _projects2 = _interopRequireDefault(_projects);

var _ProjectInfo = __webpack_require__("aJxF");

var _ProjectInfo2 = _interopRequireDefault(_ProjectInfo);

var _ProjectGallery = __webpack_require__("CNFm");

var _ProjectGallery2 = _interopRequireDefault(_ProjectGallery);

var _ProjectTimeline = __webpack_require__("lCYZ");

var _ProjectTimeline2 = _interopRequireDefault(_ProjectTimeline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ProjectList',
  metaInfo: {
    title: 'my projects',
    meta: [{
      vmid: 'description',
      name: 'description',
      content: "You can see Edmond Yip's projects here, included ux/ui design, web design, info graph, frond-end development, seo and blog. "
    }]
  },
  data: function data() {
    var _this = this;

    return {
      list: _projects2.default.projects,
      projectId: _projects2.default.projects.findIndex(function (obj) {
        return obj.path === _this.$route.params.url;
      }),
      loading: false
    };
  },
  components: {
    ProjectInfo: _ProjectInfo2.default,
    ProjectGallery: _ProjectGallery2.default,
    ProjectTimeline: _ProjectTimeline2.default
  },
  methods: {
    updateProject: function updateProject(id) {
      console.log(id - 1);
      self = this;
      self.loading = true;
      setTimeout(function () {
        self.projectId = _projects2.default.projects.findIndex(function (obj) {
          return obj.path === self.$route.params.url;
        });
        self.$router.push({
          name: 'project',
          params: {
            url: self.list[id - 1].path
          }
        });
        self.loading = false;
      }, 800);
    },
    backProject: function backProject() {
      self = this;
      self.loading = true;
      setTimeout(function () {
        self.$router.push({
          name: 'project',
          params: {
            url: self.list[self.projectId -= 1].path
          }
        });
        self.loading = false;
      }, 800);
    },
    nextProject: function nextProject() {
      self = this;
      self.loading = true;
      setTimeout(function () {
        self.$router.push({
          name: 'project',
          params: {
            url: self.list[self.projectId += 1].path
          }
        });
        self.loading = false;
      }, 800);
    }
  },
  watch: {
    '$route': function $route(to, from) {
      var _this2 = this;

      projectId: _projects2.default.projects.findIndex(function (obj) {
        return obj.path === _this2.$route.params.url;
      });
    }
  }
};

/***/ }),

/***/ "YaEn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__("/ocq");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _vueMeta = __webpack_require__("p3jY");

var _vueMeta2 = _interopRequireDefault(_vueMeta);

var _PageNotFound = __webpack_require__("gIJJ");

var _PageNotFound2 = _interopRequireDefault(_PageNotFound);

var _PageIndex = __webpack_require__("EAr1");

var _PageIndex2 = _interopRequireDefault(_PageIndex);

var _PageAbout = __webpack_require__("YlF/");

var _PageAbout2 = _interopRequireDefault(_PageAbout);

var _ProjectList = __webpack_require__("D91m");

var _ProjectList2 = _interopRequireDefault(_ProjectList);

var _PageContact = __webpack_require__("fzps");

var _PageContact2 = _interopRequireDefault(_PageContact);

var _ContactComments = __webpack_require__("itgH");

var _ContactComments2 = _interopRequireDefault(_ContactComments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vueMeta2.default);

exports.default = new _vueRouter2.default({
  mode: 'history',
  routes: [{
    name: 'error',
    path: '*',
    component: _PageNotFound2.default
  }, {
    name: 'home',
    path: '/',
    component: _PageIndex2.default
  }, {
    name: 'about',
    path: '/about',
    component: _PageAbout2.default
  }, {
    name: 'projects',
    path: '/projects',
    redirect: '/projects/eventor'
  }, {
    name: 'project',
    path: '/projects/:url',
    component: _ProjectList2.default
  }, {
    name: 'contact',
    path: '/contact',
    component: _PageContact2.default
  }, {
    name: 'comments',
    path: '/comments',
    component: _ContactComments2.default
  }]
});

/***/ }),

/***/ "YlF/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageAbout_vue__ = __webpack_require__("k+uK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageAbout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageAbout_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageAbout_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageAbout_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25a0f487_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageAbout_vue__ = __webpack_require__("YvYa");
function injectStyle (ssrContext) {
  __webpack_require__("ORkw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25a0f487"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageAbout_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25a0f487_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageAbout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "YvYa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about-cover"},[_c('section',{staticClass:"about-me"},[_vm._m(0),_vm._v(" "),_c('personal-profile',{staticClass:"info"})],1),_vm._v(" "),_c('section',{staticClass:"about-skills"},[_c('personal-skills')],1),_vm._v(" "),_c('section',{staticClass:"about-256"},[_vm._m(1),_vm._v(" "),_c('website-info',{staticClass:"info"})],1),_vm._v(" "),_c('section',{staticClass:"about-stack"},[_c('tech-stack')],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image"},[_c('header',[_c('h1',[_vm._v("Edmond Yip")]),_vm._v(" "),_c('h1',[_vm._v("Designer")]),_vm._v(" "),_c('h1',[_vm._v("Developer")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image"},[_c('header',[_c('h1',[_vm._v("256pages.com")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZLs2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageHeader_vue__ = __webpack_require__("G6WW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageHeader_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageHeader_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageHeader_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_398d6f24_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageHeader_vue__ = __webpack_require__("fiNI");
function injectStyle (ssrContext) {
  __webpack_require__("hSJM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-398d6f24"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageHeader_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_398d6f24_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ZrdO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "a3je":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'About256'
};

/***/ }),

/***/ "aJxF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectInfo_vue__ = __webpack_require__("v4BC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectInfo_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectInfo_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectInfo_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b5035cf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectInfo_vue__ = __webpack_require__("Tz0M");
function injectStyle (ssrContext) {
  __webpack_require__("wwMv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0b5035cf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectInfo_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b5035cf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "bqfK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/student.95e18cf.png";

/***/ }),

/***/ "bwqR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/index.7bcfaf8.jpg";

/***/ }),

/***/ "c7ST":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageSmallTag_vue__ = __webpack_require__("ig/Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageSmallTag_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageSmallTag_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageSmallTag_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageSmallTag_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b782db6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageSmallTag_vue__ = __webpack_require__("T0ue");
function injectStyle (ssrContext) {
  __webpack_require__("ZrdO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b782db6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageSmallTag_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b782db6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageSmallTag_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "cUoY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cover.013ad21.jpg";

/***/ }),

/***/ "d7qu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('legend',[_vm._v("leave me a message")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cmName),expression:"cmName"}],attrs:{"type":"text","placeholder":"name"},domProps:{"value":(_vm.cmName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cmName=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cmEmail),expression:"cmEmail"}],attrs:{"type":"text","placeholder":"email"},domProps:{"value":(_vm.cmEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cmEmail=$event.target.value}}}),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.cmContent),expression:"cmContent"}],attrs:{"type":"text","placeholder":"message..."},domProps:{"value":(_vm.cmContent)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cmContent=$event.target.value}}}),_vm._v(" "),(_vm.message === '')?_c('button',{on:{"click":_vm.sendComment}},[_vm._v("send")]):_c('button',{attrs:{"disabled":""}},[_vm._v(_vm._s(_vm.message))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "djIF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/login.2f3f044.jpg";

/***/ }),

/***/ "dqWU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PageSmallTag = __webpack_require__("c7ST");

var _PageSmallTag2 = _interopRequireDefault(_PageSmallTag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Footer',
  components: {
    SmallTag: _PageSmallTag2.default
  }
};

/***/ }),

/***/ "eYBB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('span',{style:({top: (_vm.projectId) * 33 + 8 + 'px'})}),_vm._v(" "),_c('ul',[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eljf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f7M/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutMe_vue__ = __webpack_require__("o+Pu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutMe_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutMe_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutMe_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutMe_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_067652c3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutMe_vue__ = __webpack_require__("P7HO");
function injectStyle (ssrContext) {
  __webpack_require__("nEbm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-067652c3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutMe_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_067652c3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutMe_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "fAhw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About256Stack_vue__ = __webpack_require__("a3je");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About256Stack_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About256Stack_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About256Stack_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About256Stack_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_627510e8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About256Stack_vue__ = __webpack_require__("jRVt");
function injectStyle (ssrContext) {
  __webpack_require__("9uml")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-627510e8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About256Stack_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_627510e8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About256Stack_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "fY3Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNavbar_vue__ = __webpack_require__("OOQz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNavbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNavbar_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNavbar_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNavbar_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_155cd7b7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageNavbar_vue__ = __webpack_require__("9p8q");
function injectStyle (ssrContext) {
  __webpack_require__("jV63")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-155cd7b7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNavbar_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_155cd7b7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageNavbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "fZ15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.mobileCheck === true)?_c('svg',{attrs:{"id":"background-svg","xml:space":"preserve","viewBox":"0 0 480 720","preserveAspectRatio":"none"}},_vm._l((_vm.bgList),function(bg){return _c('g',{key:bg.id,staticStyle:{"display":"none"},attrs:{"id":bg.name}},_vm._l((bg.mobile),function(svgPath){return _c('path',{key:svgPath.id,attrs:{"d":svgPath}})}))})):_c('svg',{attrs:{"id":"background-svg","xml:space":"preserve","viewBox":"0 0 720 480","preserveAspectRatio":"xMidYMid"}},_vm._l((_vm.bgList),function(bg){return _c('g',{key:bg.id,staticStyle:{"display":"none"},attrs:{"id":bg.name}},_vm._l((bg.path),function(svgPath){return _c('path',{key:svgPath.id,attrs:{"d":svgPath}})}))}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ffvQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/propic.98479d5.png";

/***/ }),

/***/ "fiNI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{class:{scrolled: _vm.scrolled === true, home: _vm.routeName === 'home'}},[_c('div',{staticClass:"nav-btn",on:{"click":function($event){_vm.navOpen = !_vm.navOpen}}},[_c('svg',{attrs:{"id":"mobile-btn","xmlns":"http://www.w3.org/2000/svg","xml:space":"preserve","viewBox":"0 0 25 25","preserveAspectRatio":"none"}},[_c('g',{attrs:{"id":"close"}},[_c('polygon',{attrs:{"points":"23,4.7 20.3,2 12.5,9.8 4.7,2 2,4.7 9.8,12.5 2,20.3 4.7,23 12.5,15.2 20.3,23 23,20.3 15.2,12.5"}})]),_vm._v(" "),_c('g',{attrs:{"id":"open"}},[_c('rect',{attrs:{"x":"3","y":"5","width":"19","height":"3"}}),_vm._v(" "),_c('rect',{attrs:{"x":"3","y":"11","width":"19","height":"3"}}),_vm._v(" "),_c('rect',{attrs:{"x":"3","y":"17","width":"19","height":"3"}})])])]),_vm._v(" "),_c('navbar',{class:{open: _vm.navOpen}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fzps":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageContact_vue__ = __webpack_require__("RPYb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageContact_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageContact_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageContact_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageContact_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f8caed1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageContact_vue__ = __webpack_require__("+6aW");
function injectStyle (ssrContext) {
  __webpack_require__("TuCX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f8caed1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageContact_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f8caed1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageContact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "g95J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"tag"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gH4x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[_c('h2',[_vm._v("About this website")]),_vm._v(" "),_c('p',[_vm._v("I design this website for my portfolio. Not the projects page, this is just a practice. This website created by different tech I know.")]),_vm._v(" "),_c('p',[_vm._v("This website used VueJs as main framework, on a ubuntu server and using nginx for reverse proxy server. I generated static html by server side rendering, for better site performance and SEO crawling allowable.")]),_vm._v(" "),_c('p',[_vm._v("I also build a Rest API for contact list comments. I can check comments anytime!")]),_vm._v(" "),_c('p',[_vm._v("For this website, I create 2 projects - "),_c('a',{attrs:{"href":"https://github.com/edmondyip/ChineseFonts"}},[_vm._v("Chinese Fonts")]),_vm._v(" & "),_c('a',{attrs:{"href":"https://github.com/edmondyip/vue-svg-morpheus"}},[_vm._v("Vue SVG Morpheus")]),_vm._v(". I will try to keep update these projects if i can.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gIJJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNotFound_vue__ = __webpack_require__("2h4B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNotFound_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNotFound_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNotFound_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNotFound_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40fdbe76_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageNotFound_vue__ = __webpack_require__("0jOp");
function injectStyle (ssrContext) {
  __webpack_require__("xYN5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-40fdbe76"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNotFound_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40fdbe76_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageNotFound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "gJL2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mobile.b88c79d.jpg";

/***/ }),

/***/ "gYFG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/login.bb36444.jpg";

/***/ }),

/***/ "hSJM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hnXK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/request.6df2a34.jpg";

/***/ }),

/***/ "iJV7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectType_vue__ = __webpack_require__("iMtk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectType_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectType_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectType_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectType_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a81b4182_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectType_vue__ = __webpack_require__("g95J");
function injectStyle (ssrContext) {
  __webpack_require__("T2l3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a81b4182"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectType_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a81b4182_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectType_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "iMtk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),

/***/ "iNIn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/collection.23daa17.jpg";

/***/ }),

/***/ "iWyS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageFooter_vue__ = __webpack_require__("dqWU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageFooter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageFooter_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageFooter_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageFooter_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_660a9265_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageFooter_vue__ = __webpack_require__("j+Bk");
function injectStyle (ssrContext) {
  __webpack_require__("ikA+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-660a9265"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageFooter_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_660a9265_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "iZYo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/login.7adb09c.jpg";

/***/ }),

/***/ "ig/Y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'Tag'
};

/***/ }),

/***/ "ikA+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "itgH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactComments_vue__ = __webpack_require__("4cvJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactComments_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactComments_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactComments_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactComments_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5765ee0a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactComments_vue__ = __webpack_require__("Vg2l");
function injectStyle (ssrContext) {
  __webpack_require__("XWXL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5765ee0a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactComments_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5765ee0a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactComments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "j+Bk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"copyAnimation","appear":"","appear-active-class":"copy-animation"}},[_c('footer',[_c('small-tag'),_vm._v(" "),_c('div',{attrs:{"id":"copyright"}},[_vm._v("\n      256pages © 2017\n    ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j547":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jRVt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[_c('section',[_c('h2',[_vm._v("Front-end")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"https://vuejs.org/","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Vuejs")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://sass-lang.com/","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Sass")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://necolas.github.io/normalize.css/","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Normalize.css")])])])]),_vm._v(" "),_c('section',[_c('h2',[_vm._v("Server Side")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"https://www.ubuntu.com/","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Ubuntu")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.nginx.com/","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Nginx")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://nodejs.org/en/","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Nodejs")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://webpack.js.org/","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Webpack")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://expressjs.com/","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Express")])])])]),_vm._v(" "),_c('section',[_c('h2',[_vm._v("Font type")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"https://moji-waku.com/","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("kaiso")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://fonts.google.com/specimen/Ubuntu","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Ubuntu")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://fonts.google.com/specimen/Open+Sans","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Open Sans")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jV63":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jzfu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k+uK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AboutMe = __webpack_require__("f7M/");

var _AboutMe2 = _interopRequireDefault(_AboutMe);

var _About = __webpack_require__("3PfS");

var _About2 = _interopRequireDefault(_About);

var _AboutSkills = __webpack_require__("BBC3");

var _AboutSkills2 = _interopRequireDefault(_AboutSkills);

var _About256Stack = __webpack_require__("fAhw");

var _About256Stack2 = _interopRequireDefault(_About256Stack);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'About',
  metaInfo: {
    title: 'about edmond & website'
  },
  data: function data() {
    return {};
  },
  components: {
    PersonalProfile: _AboutMe2.default,
    WebsiteInfo: _About2.default,
    PersonalSkills: _AboutSkills2.default,
    TechStack: _About256Stack2.default
  }
};

/***/ }),

/***/ "kNH2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/blog.38b8c5f.jpg";

/***/ }),

/***/ "kxZM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dashboard.bb85edc.jpg";

/***/ }),

/***/ "lCYZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectTimeline_vue__ = __webpack_require__("o2f0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectTimeline_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectTimeline_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectTimeline_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectTimeline_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b8ed629_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectTimeline_vue__ = __webpack_require__("eYBB");
function injectStyle (ssrContext) {
  __webpack_require__("j547")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7b8ed629"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectTimeline_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b8ed629_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectTimeline_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "lQpg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lRq9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dashboard.a6f5410.jpg";

/***/ }),

/***/ "lVK7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__("M93x");

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__("YaEn");

var _router2 = _interopRequireDefault(_router);

var _vueProgressbar = __webpack_require__("zYko");

var _vueProgressbar2 = _interopRequireDefault(_vueProgressbar);

var _is_js = __webpack_require__("oQbg");

var _is_js2 = _interopRequireDefault(_is_js);

__webpack_require__("0AzE");

__webpack_require__("4JzW");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var options = {
  color: '#85F1C1',
  failedColor: '#874b4b',
  thickness: '3px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  location: 'top',
  inverse: false
};

_vue2.default.use(_vueProgressbar2.default, options);

_vue2.default.mixin({
  data: function data() {
    return {
      routeName: this.$route.name,

      windowWidth: document.documentElement.clientWidth,
      windowHeight: document.documentElement.clientHeight,
      mobileCheck: false
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      window.addEventListener('resize', this.getWindowSize);
    });
  },
  methods: {
    getWindowSize: function getWindowSize(event) {
      this.windowWidth = document.documentElement.clientWidth;
      this.windowHeight = document.documentElement.clientHeight;
      this.mobileCheck = _is_js2.default.touchDevice();
    }
  },
  created: function created() {
    this.routeName = this.$route.name;
    this.mobileCheck = _is_js2.default.touchDevice();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.getWindowSize);
  },
  watch: {
    '$route': function $route(to, from) {
      this.routeName = this.$route.name;
    }
  }
});

_vue2.default.config.productionTip = false;

new _vue2.default({
  el: '#app',
  router: _router2.default,
  template: '<App/>',
  components: {
    App: _App2.default
  }
});

/***/ }),

/***/ "lWha":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video-banner')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mEwG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mgRi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/project.a4b53ed.jpg";

/***/ }),

/***/ "nEbm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o+Pu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'AboutMe'
};

/***/ }),

/***/ "o2f0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'Timeline',
  props: ['projectId']
};

/***/ }),

/***/ "pBNn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qgFt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/circle.66cb65a.png";

/***/ }),

/***/ "skdO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tQKA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/comment.0354055.png";

/***/ }),

/***/ "ttFu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/infographic.ea6d11d.jpg";

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "uwKF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ux.8f00e12.jpg";

/***/ }),

/***/ "v4BC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ProjectType = __webpack_require__("iJV7");

var _ProjectType2 = _interopRequireDefault(_ProjectType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ProjectItem',
  props: ['projectId', 'list'],
  data: function data() {
    return {};
  },
  components: {
    ProjectType: _ProjectType2.default
  }
};

/***/ }),

/***/ "vu0j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[_c('section',[_c('h2',[_vm._v("Skills")]),_vm._v(" "),_c('ul',{staticClass:"skill-bar"},_vm._l((_vm.skills),function(skill){return _c('li',{key:skill.name},[_c('span',{class:{zero: _vm.loadBar === false},style:({width: skill.percent + '%'})},[_vm._v(_vm._s(skill.percent + '%'))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(skill.name))])])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vv4A":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cover.f2df800.jpg";

/***/ }),

/***/ "wgy/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ux.52b3024.jpg";

/***/ }),

/***/ "wwMv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x/g7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bg.539dfd7.mp4";

/***/ }),

/***/ "xJD8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PageHeader = __webpack_require__("ZLs2");

var _PageHeader2 = _interopRequireDefault(_PageHeader);

var _PageFooter = __webpack_require__("iWyS");

var _PageFooter2 = _interopRequireDefault(_PageFooter);

var _PageBackground = __webpack_require__("V3qm");

var _PageBackground2 = _interopRequireDefault(_PageBackground);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Layout',
  metaInfo: function metaInfo() {
    return {
      title: '256pages',
      titleTemplate: '%s | 256pages',

      link: [{
        rel: 'stylesheet',
        href: 'https://fonts.googleapis.com/css?family=Open+Sans|Ubuntu:300,400'
      }, {
        rel: 'author',
        href: 'https://256pages.com/humans.txt'
      }, {
        rel: 'canonical',
        href: 'https://256pages.com' + this.routePath
      }]
    };
  },
  mouted: function mouted() {
    this.$Progress.finish();
  },
  created: function created() {
    var _this = this;

    console.log(this.$route.name);
    this.$Progress.start();
    this.$router.beforeEach(function (to, from, next) {
      if (to.meta.progress !== undefined) {
        var meta = to.meta.progress;
        _this.$Progress.parseMeta(meta);
      }
      _this.$Progress.start();
      next();
    });
    this.$router.afterEach(function (to, from) {
      _this.$Progress.finish();
    });
  },
  components: {
    PageHeader: _PageHeader2.default,
    PageFooter: _PageFooter2.default,
    BackgroundAnimation: _PageBackground2.default
  }
};

/***/ }),

/***/ "xXGj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xYN5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y+Dm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _IndexVideo = __webpack_require__("QZV/");

var _IndexVideo2 = _interopRequireDefault(_IndexVideo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'IndexPage',
  metaInfo: {
    title: "edmond yip's personal website",
    meta: [{
      vmid: 'description',
      name: 'description',
      content: "Welcome to Edmond Yip's personal website. Edmond Yip is a Full stack designer + developer. This website built by VueJS."
    }]
  },
  components: {
    VideoBanner: _IndexVideo2.default
  }
};

/***/ })

},["lVK7"]);


// WEBPACK FOOTER //
// static/js/app.c130beccd41de0416463.js